import React from "react";
import PropTypes from "prop-types";
import Query from "components/Query";
import ErrorMessage from "components/ErrorMessage";

const Message = React.memo(({ className, url }) => (
  <div className={`container chairmans-msg-wrapper ${className}`} style={{marginLeft: 0, marginRight: 0, paddingLeft: 0,paddingRight: 0, maxWidth: "100%"}}>
    <Query url={url}>
      {({ data }) => (
        <>
          {!data && <ErrorMessage message="No data" />}
          {data && (
            // <div className="row">
            //   <div className="col-lg-7">
            //     <div className="chairmans-content wow fadeInUp">
            //       <h1 className="main-heading">
            //         <img
            //           src="/resources/img/sabinehospital-icons/sabinehospital-heartbeat.svg"
            //           alt=""
            //         />
            //         {data.title}
            //       </h1>
            //       <div className="ql-editor" dangerouslySetInnerHTML={{ __html: data.content }} />
            //       {/* <p>{data.contentText}</p> */}
            //       {/* <p>
            //         It is my privilege to introduce you to SHRC- the most innovative, successful and
            //         technologically advanced institution in the field of infertility treatment,IVF
            //         and ICSI. Our success is based on its excellence and commitment in the
            //         speciality. To grow, prosper and remain sustainable we embrace technology and
            //         transformation.
            //       </p>
            //       <p>
            //         Teamwork, speed and quality are the cornerstones of SHRC.These qualities
            //         permeate the hospital’s entire organisational culture. Shared commitment, clear
            //         intent and a solid plan of action ensures we remain the best in the field of
            //         infertility treatment
            //       </p>
            //       <p>
            //         I welcome you all to our website to have a detailed experience of our hospital
            //         services.
            //       </p>
            //       <h5>Have a great day</h5> */}
            //     </div>
            //   </div>
            //   <div className="col-lg-5">
            //     <div className="chairman-image-wrapper wow fadeInUp">
            //       <div className="chairman-image">
            //         <img
            //           src={`${process.env.REACT_APP_BASE_URL}/${data.mainImage.url}`}
            //           alt={data.imageTag}
            //           className="img-fluid"
            //         />
            //       </div>
            //       <div className="greetings-wrapper">
            //         <p>Greetings & Welcome</p>
            //         <h4>Dr. Sabine Sivadasan</h4>
            //       </div>
            //     </div>
            //   </div>
            // </div>
            <>
              <div className="doctor-message-wrapper wow fadeInUp">
                <img className="waves-desktop" src="/img/Wave-desktop.svg"/>
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/${data.mainImage.url}`}
                  className="chairman-image wow slideInLeft"
                />
                <div className="chairman-message-text wow slideInRight">
                  <h2>Chariman’s Message</h2>
                  <h3>Dr. Sabine Sivadasan</h3>
                  <img src="/img/double-coma-white.svg" />

                  <span>
                    It is my privilege to introduce you to Sabine Hospital - the
                    most innovative, successful and technologically advanced
                    institution in the field of infertility treatment, IVF and
                    ICSI. Our success is based on its excellence and commitment
                    to the speciality. To grow, prosper and remain sustainable
                    we embrace technology and transformation. Teamwork, speed
                    and quality are the cornerstones of Sabine Hospital. These
                    qualities permeate the hospital’s entire organisational
                    culture. Shared commitment, clear intent and a solid plan of
                    action ensure we remain the best in the field of infertility
                    treatment. I welcome you all to our website to have a
                    detailed experience of our hospital services.
                    <br />
                    <br /> Have a great day!
                  </span>
                </div>
              </div>
              <div className="doctor-message-wrapper-mobile">
              <img className="waves-mobile" src="/img/Wave-phone.svg"/>
                <div className="chairman-message-text-mobile">
                  <div
                  className="wow slideInLeft"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "16.7px",
                      marginLeft: "14px",
                    }}
                  >
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/${data.mainImage.url}`}
                      className="chairman-image-mobile"
                    />
                    <div>
                      <h2>Chariman’s Message</h2>
                      <h3>Dr. Sabine Sivadasan</h3>
                    </div>
                  </div>
                  <img className="wow slideInLeft" src="/img/double-coma-white.svg" />

                  <span className="wow slideInRight">
                    It is my privilege to introduce you to Sabine Hospital - the
                    most innovative, successful and technologically advanced
                    institution in the field of infertility treatment, IVF and
                    ICSI. Our success is based on its excellence and commitment
                    to the speciality. To grow, prosper and remain sustainable
                    we embrace technology and transformation. Teamwork, speed
                    and quality are the cornerstones of Sabine Hospital. These
                    qualities permeate the hospital’s entire organisational
                    culture. Shared commitment, clear intent and a solid plan of
                    action ensure we remain the best in the field of infertility
                    treatment. I welcome you all to our website to have a
                    detailed experience of our hospital services.
                    <br />
                    <br /> Have a great day!
                  </span>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </Query>
  </div>
));

Message.propTypes = {
  className: PropTypes.string,
};

Message.defaultProps = {
  className: "",
};

export default Message;
